let $strengthIndicator = $('.js-strength-indicator');
if ($strengthIndicator.length > 0) {
    $(document).on('keyup', 'input[name="password"]', function () {
        let value = $(this).val(),
            total = 0;

        $strengthIndicator.removeClass(function (index, css) {
            return (css.match(/(^|\s)__\S+/g) || []).join(' ');
        });

        if (value.length >= 6) {
            total++;
        }

        if (/[A-Z]/.test(value)) {
            total++;
        }

        if (/[0-9]/.test(value)) {
            total++;
        }

        if (/^[a-zA-Z0-9- ]*$/.test(value) === false) {
            total++;
        }

        if (value.length < 6) {
            total = 0;
            $strengthIndicator.addClass('_short');
        } else {
            $strengthIndicator.removeClass('_short');
        }

        switch (total) {
            case 1:
                $strengthIndicator.addClass('__weak');
                break;
            case 2:
                $strengthIndicator.addClass('__bad');
                break;
            case 3:
                $strengthIndicator.addClass('__good');
                break;
            case 4:
                $strengthIndicator.addClass('__strong');
                break;
        }
    });
}
